const blogTitle = 'Rocket Resume Resources';

export default blogTitle;
